export const ToolbarConfig = [
  ['undo', 'redo'],
  ['bold', 'italic', 'underline', 'strike'],
  [{ header: 1 }, { header: 2 }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: 'justify' }, { align: 'center' }, { align: 'right' }],
];
